import React from "react";
import {motion} from "framer-motion"
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2010 - 2022</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Motion Graphic Artist"
            // subTitle="Google Out Tech - (2017 - Present)"
            result="Lucknow"
            des="Creative and dedicated motion graphic artist with one year of experience in developing dynamic animations and video content.
Proficient in Adobe After Effects and Premiere Pro, with a strong foundation in graphic design principles.
Seeking an opportunity to contribute to a forward-thinking media team's hiring process is an important part of our culture. Googlers care deeply about their teams and the people who make them up."
          />
          <ResumeCard
            title="Graphic Designer"
            // subTitle="Apple Developer Team - (2012 - 2016)"
            result="Lucknow"
            des="Creative graphic designer with four years of experience in print and digital design.
Proficient in Adobe Creative Suite, specializing in branding, marketing materials, and political graphic.
Strong collaborative skills with a keen eye for detail and a passion for innovative design solutions. popular destination with a growing number of highly qualified homegrown graduates, it's true that securing a role in Malaysia isn't easy."
          />
       
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;